import React, { useState, useEffect } from "react";
import Sidebar from "../../../Components/Sidebar";
import { LuTarget, LuUserCheck } from "react-icons/lu";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchVisionData, updateVisionData } from "../../../redux/actions/aboutUsActions";
import PageComponent from "../../../Components/PageComponent";
import { FaHistory } from "react-icons/fa";

function About_SAB() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { data: visionData, loading } = useSelector((state) => state.aboutUs.vision);

  const [id, setId] = useState(null);
  const [vision, setVision] = useState("");
  const [mission, setMission] = useState("");

  useEffect(() => {
    dispatch(fetchVisionData());
  }, [dispatch]);

  useEffect(() => {
    if (visionData) {
      setId(visionData.id || null);
      setVision(visionData.vision || "");
      setMission(visionData.mission || "");
    }
  }, [visionData]);

  const handleUpdate = (e) => {
    e.preventDefault();
    if (!id) {
      alert("ID is missing. Unable to update vision and mission.");
      return;
    }
    dispatch(updateVisionData(id, vision, mission));
  };

  return (
    <><PageComponent>
    <div className="flex w-screen h-screen overflow-x-hidden bg-[#F8F7FA]">
      <div className="fixed top-0 left-0 w-64 h-full overflow-y-auto bg-white shadow-md">
        <Sidebar />
      </div>
      <div className="flex-1 p-6 ml-64">
        <div className="flex items-center space-x-2 text-3xl text-gray-500">
          <span>About Us</span>
          <span>/</span>
          <span className="text-black">About SAB Campus</span>
        </div>
        <div className="flex items-center mt-4 space-x-4">
          <button
            className="flex items-center px-4 py-2 text-white bg-[#92288C] rounded-lg shadow hover:bg-[#6C0B67]"
            onClick={() => navigate("/aboutus/vision")}
          >
            <LuTarget className="mr-2" />
            Vision & Mission
          </button>
           <button
              className="flex items-center px-4 py-2 text-[#A8AAAE] rounded-lg shadow hover:bg-gray-100"
              onClick={() => navigate("/aboutus/history")}
            >
              <FaHistory className="mr-2" />
              Our History
            </button>
          <button
            className="flex items-center px-4 py-2 text-[#A8AAAE] rounded-lg shadow hover:bg-gray-100"
            onClick={() => navigate("/aboutus/leadershipMessage")}
          >
            <LuUserCheck className="mr-2" />
            Leadership Messages
          </button>
        </div>
        <div className="p-6 mt-6 bg-white rounded-lg shadow-md">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <form onSubmit={handleUpdate}>
              <div className="space-y-4">
                <div>
                  <label className="block text-gray-700">Update Vision Message</label>
                  <textarea
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                    placeholder="Enter vision message"
                    value={vision}
                    onChange={(e) => setVision(e.target.value)}
                    style={{ height: "100px", resize: "none" }}
                  />
                </div>
                <div>
                  <label className="block text-gray-700">Update Mission Message</label>
                  <textarea
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                    placeholder="Enter mission message"
                    value={mission}
                    onChange={(e) => setMission(e.target.value)}
                    style={{ height: "100px", resize: "none" }}
                  />
                </div>
              </div>
              <div className="flex justify-end mt-6 space-x-4">
                <button
                  type="reset"
                  onClick={() => {
                    setVision(visionData?.vision || "");
                    setMission(visionData?.mission || "");
                  }}
                  className="px-4 py-2 text-[#A8AAAE] bg-gray-200 rounded-md hover:bg-gray-300"
                >
                  Clear
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 text-white bg-[#92288C] rounded-md hover:bg-[#6C0B67]"
                >
                  Update
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
    </PageComponent></>
  );
}

export default About_SAB;
